/**
 * @param {import("../../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/bookings/:bookingId/guests",
    },
    (router) => {
      router.push({
        id: "@api/booking.guest@search",
        path: "",
      });
      router.push({
        id: "@api/booking.guest@create",
        path: "",
      });
      router.group(
        {
          path: "/:guestId",
        },
        (router) => {
          router.push({
            id: "@api/booking.guest@show",
            path: "",
          });
          router.push({
            id: "@api/booking.guest@update",
            path: "",
          });
          router.push({
            id: "@api/booking.guest@delete",
            path: "",
          });
        },
      );
    },
  );
}
